import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { HeroSecondary } from "../headers/HeroSecondary";
import { SectionGridTwoColumns } from "../sections/grids/SectionGridTwoColumns";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionBlockTextColumns } from "../sections/blocks/SectionBlockTextColumns";
import { CardArchive } from "../components/cards/CardArchive";
import { SectionBlockPinnedMediaItems } from "../sections/blocks/SectionBlockPinnedMediaItems";
import { SectionBlockAccordionContent } from "../sections/blocks/SectionBlockAccordionContent";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";
import { SectionForm } from "../sections/blocks/SectionForm";
import kebabCase from "lodash.kebabcase";
import { CardTile } from "../components/cards/CardTile";
import { SectionBlockStatsAlt } from "../sections/blocks/SectionBlockStatsAlt";
import { SectionBlockMediaItem } from "../sections/blocks/SectionBlockMediaItem";

export interface ITemplatePageLanding {
  data: any;
}

export default function TemplatePageLanding({ data }: ITemplatePageLanding) {
  const {
    heroSecondary,
    sectionBlockTextColumns1,
    sectionBlockStatsAlt,
    testimonial1,
    sectionBlockMediaItem,
    sectionBlockPinnedMediaItems,
    testimonial2,
    sectionBlockAccordionContent,
    sectionCardCarousel,
    sectionBlockTextColumns2,
    sectionForm,
    breadcrumbs,
    form,
  } = data;

  // console.log("TemplatePageLanding", data);
  return (
    <>
      {heroSecondary && (
        <HeroSecondary data={heroSecondary} breadcrumbs={breadcrumbs} />
      )}
      <WrapperComponents>
        {sectionBlockTextColumns1 && (
          <div id="our-mission">
            <SectionBlockTextColumns data={sectionBlockTextColumns1} />
          </div>
        )}
        {sectionBlockStatsAlt && (
          <SectionBlockStatsAlt data={sectionBlockStatsAlt} />
        )}
        {testimonial1 && <SectionBlockMediaFeatured data={testimonial1} />}
        {sectionBlockMediaItem && (
          <div id="work-with-us">
            <SectionBlockMediaItem data={sectionBlockMediaItem} />
          </div>
        )}
        {sectionBlockPinnedMediaItems && (
          <SectionBlockPinnedMediaItems data={sectionBlockPinnedMediaItems} />
        )}
        {sectionCardCarousel && (
          <div id="about-mates">
            <SectionCardCarousel data={sectionCardCarousel} cardsPerView="2">
              {sectionCardCarousel.items &&
                sectionCardCarousel.items.map((item, index) => {
                  return <CardTile card={item} key={index} />;
                })}
            </SectionCardCarousel>
          </div>
        )}
        {sectionBlockAccordionContent && (
          <div id="faqs">
            <SectionBlockAccordionContent data={sectionBlockAccordionContent} />
          </div>
        )}
        {testimonial2 && <SectionBlockMediaFeatured data={testimonial2} />}
        {sectionBlockTextColumns2 && (
          <SectionBlockTextColumns data={sectionBlockTextColumns2} />
        )}
        {sectionForm && form && (
          <div id="contact">
            <SectionForm
              id={kebabCase(sectionForm.title)}
              data={sectionForm}
              form={form}
            />
          </div>
        )}
      </WrapperComponents>
    </>
  );
}
